import React from "react"
import { Header } from "semantic-ui-react"

import SelectThesiEuthinis from "./SelectThesiEuthinis"

class CommandPositions extends React.PureComponent {
  render() {
    const { options, onChange, disabled, valueA, valueB, valueC } = this.props
    return (
      <React.Fragment>
        <Header size="tiny">Επιθυμία θέσης ευθύνης</Header>
        <label>
          ΣΥΜΠΛΗΡΩΝΕΤΑΙ ΑΠΟ ΑΞΚΟΥΣ (ΣΜΗΝΑΓΟΥ ΚΑΙ ΑΝΩ) ΚΑΙ ΓΙΑ ΠΡΣΚΟ ΤΕΧΝΙΚΩΝ
          ΕΙΔΙΚΟΤΗΤΩΝ (ΥΠΣΓΟΥ ΚΑΙ ΑΝΩ) ΕΠΙΘΥΜΙΑ ΤΟΠΟΘΕΤΗΣΗΣ ΣΕ ΘΕΣΗ ΕΥΘΥΝΗΣ
          (ΠΡΟΑΙΡΕΤΙΚΑ)
        </label>
        <SelectThesiEuthinis
          disabled={disabled}
          label="Επιλογή Α"
          name="thesiEythinisA"
          options={options}
          onChange={(name, value) => onChange(name, value)}
          value={valueA}
          exclude={[valueB, valueC]}
        />
        <SelectThesiEuthinis
          disabled={disabled}
          label="Επιλογή B"
          name="thesiEythinisB"
          options={options}
          onChange={(name, value) => onChange(name, value)}
          value={valueB}
          exclude={[valueA, valueC]}
        />
        <SelectThesiEuthinis
          disabled={disabled}
          label="Επιλογή Γ"
          name="thesiEythinisC"
          options={options}
          onChange={(name, value) => onChange(name, value)}
          value={valueC}
          exclude={[valueB, valueA]}
        />
      </React.Fragment>
    )
  }
}

export default CommandPositions
